import { useEffect, useState } from 'react';
import { useSystemStatusContext } from '../contexts/SystemStatusContext';
import type { Session } from '../types/app';
import BetaFeedbackModal from './BetaFeedbackModal';
import { BetaFeedbackIcon } from './Icons';
import { isNative } from '../platform/capacitor';
import '../styles/system-status.css';

interface BetaFeedbackButtonProps {
  session: Session;
}

export default function BetaFeedbackButton({ session }: BetaFeedbackButtonProps) {
  const { status } = useSystemStatusContext();
  const [open, setOpen] = useState(false);

  const showFab = status && (status.appEnv === 'preprod' || status.beta.mode !== 'open');

  useEffect(() => {
    function handleOpen() {
      setOpen(true);
    }
    window.addEventListener('wt-open-beta-feedback', handleOpen);
    return () => window.removeEventListener('wt-open-beta-feedback', handleOpen);
  }, []);

  if (!showFab) return null;

  return (
    <>
      {!isNative() && (
        <button
          type="button"
          className="beta-feedback-fab"
          title="Feedback beta-test"
          aria-label="Feedback beta-test"
          onClick={() => setOpen(true)}
        >
          <BetaFeedbackIcon size={22} />
        </button>
      )}
      <BetaFeedbackModal session={session} open={open} onClose={() => setOpen(false)} />
    </>
  );
}
